import { FormField, RequestStatus, Streamfield, WagtailImage } from '@/types';
import { BasePageProps, basePageWrap } from '@views/BasePage';
import React, { useState } from 'react';
import FormFields from '@components/Form/FormFields';
import RawHtml from '@components/RawHtml';
import Button from '@components/Button';
import Streamfields from '@streamfields/Streamfields';
import Hero from '@components/Hero';
import BannerImage from '@components/BannerImage';

type Props = {
  title: string;
  subtitle: string;
  before_form: Streamfield[];
  after_form: Streamfield[];
  thank_you_text: string;
  form_fields: FormField[];
  subheader: string | null;
  banner_icon_svg?: string | null;
  banner_icon_png?: WagtailImage | null;
  banner_image?: WagtailImage | null;
} & BasePageProps;

function FormPage(props: Props) {
  const {
    title = '',
    subtitle,
    subheader,
    banner_icon_svg: bannerIconSvg,
    banner_icon_png: bannerIconPng,
    form_fields: formFields,
    before_form: beforeForm,
    after_form: afterForm,
    thank_you_text: thankYouText,
    banner_image: bannerImage,
  } = props;

  const [status, setStatus] = useState<RequestStatus>('idle');

  return (
    <div className='form-page'>
      {bannerImage ? <BannerImage image={bannerImage} /> : null}
      <Hero
        title={title}
        subtitle={subheader}
        text={subtitle}
        banner_icon_svg={bannerIconSvg}
        banner_icon_png={bannerIconPng}
      />
      {beforeForm ? <Streamfields fields={beforeForm} /> : null}
      <form
        id='formular'
        className='form'
        onSubmit={async event => {
          event.preventDefault();

          const formData = new FormData(event.currentTarget);

          const data: Record<string, FormDataEntryValue | FormDataEntryValue[]> =
            Object.fromEntries(formData);

          formFields.forEach(field => {
            if (field.field_type !== 'checkboxes') return;
            data[field.clean_name] = formData.getAll(field.clean_name);
          });

          try {
            setStatus('loading');
            const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/v2/forms/`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                page: formFields?.[0]?.page_id,
                form_data: JSON.stringify(data),
              }),
            });

            if (res.ok) {
              setStatus('success');
            } else {
              setStatus('error');
            }
          } catch {
            setStatus('error');
          }
        }}
      >
        <FormFields formFields={formFields} />
        {status === 'success' ? (
          <div className='message message--success'>
            <RawHtml html={thankYouText} />
          </div>
        ) : null}
        {status === 'error' ? (
          <div className='message message--error'>
            <p>Leider ist etwas schief gegangen... Bitte versuchen Sie es später erneut...</p>
            <p>
              Alternativ können Sie Ihre Anfrage auch direkt an die E-Mail-Adresse{' '}
              <a href='mailto:freizeit@stadtwerke-witten.de'>freizeit@stadtwerke-witten.de</a>{' '}
              senden.
            </p>
          </div>
        ) : null}
        <Button
          primary
          isSubmit
          disabled={status === 'loading' || status === 'success'}
          className='form__submit'
        >
          Absenden
        </Button>
      </form>
      {afterForm ? <Streamfields fields={afterForm} /> : null}
    </div>
  );
}

export default basePageWrap<Props>(FormPage);
